import { ColorScheme } from '@design/design-tokens/themes/themes';
import clsx from 'clsx';

import styles from './HeaderLogotype.module.scss';

export interface HeaderLogotypeProps {
  className?: string;
  colorScheme?: ColorScheme;
}

export const HeaderLogotype = ({
  className,
  colorScheme = ColorScheme.Dark,
  ...rest
}: HeaderLogotypeProps) => {
  const logoSrc = `/app/static/images/brand/logo-${colorScheme}.svg`;
  const logoMiniSrc = `/app/static/images/brand/logo-v2-mini-dark.svg`;

  return (
    <div className={clsx(styles.root, className)} {...rest}>
      <img className={styles.logo} src={logoSrc} alt="logo" />
      <img
        className={styles.logoMini}
        src={logoMiniSrc}
        height={20}
        width={30}
        alt="logo mini"
      />
    </div>
  );
};
